/*
 * Fiche produit BMB — galerie et bandes depliantes.
 *
 * La galerie est une piste a defilement natif : le glissement au doigt, l'inertie
 * et l'accrochage sont deja fournis par le navigateur. Le script n'ajoute que ce
 * que le CSS ne sait pas faire — les pastilles, l'etat des fleches, et le saut
 * vers le visuel d'une variante.
 */
(function () {
  'use strict';

  function initGalerie(piste) {
    var id = piste.dataset.bmbGalerie;
    var scene = piste.closest('.bmb-produit__scene');
    if (!scene) return;

    var vues = Array.prototype.slice.call(piste.children);
    if (vues.length < 2) return;

    var media = scene.closest('.bmb-produit__media') || document;
    var compteur = scene.querySelector('[data-bmb-compteur="' + id + '"] span');
    var avant = scene.querySelector('[data-bmb-suivant="' + id + '"]');
    var arriere = scene.querySelector('[data-bmb-precedent="' + id + '"]');
    var rail = media.querySelector('[data-bmb-rail="' + id + '"]');
    var vignettes = rail ? Array.prototype.slice.call(rail.querySelectorAll('[data-bmb-va-a]')) : [];

    /* Une seule image est prioritaire au chargement initial. Quand le visiteur
       manifeste l'intention de changer de visuel, on reveille uniquement la
       cible : le navigateur choisit alors la bonne largeur depuis `srcset`,
       sans mettre les vingt photos en concurrence avec le LCP. */
    function preparer(i) {
      var vue = vues[Math.max(0, Math.min(i, vues.length - 1))];
      var image = vue && vue.querySelector('img[loading="lazy"]');
      if (!image) return;
      image.loading = 'eager';
      image.fetchPriority = 'auto';
    }

    vignettes.forEach(function (v, i) {
      v.addEventListener('pointerenter', function () { preparer(i); }, { passive: true });
      v.addEventListener('focus', function () { preparer(i); });
      v.addEventListener('click', function () {
        allerA(i);
      });
    });

    function indexCourant() {
      /* Position deduite du defilement plutot que d'un compteur maintenu a la
         main : le doigt, la molette et le clavier font tous defiler la piste,
         et un compteur separe finirait par mentir. */
      var largeur = piste.clientWidth;
      if (!largeur) return 0;
      return Math.round(piste.scrollLeft / largeur);
    }

    function allerA(i) {
      var index = Math.max(0, Math.min(i, vues.length - 1));
      preparer(index);
      var cible = vues[index];
      if (cible) piste.scrollTo({ left: cible.offsetLeft - piste.offsetLeft, behavior: 'smooth' });
    }

    function rafraichir() {
      var i = indexCourant();
      if (compteur) compteur.textContent = String(i + 1);
      vignettes.forEach(function (v, j) {
        v.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
      /* En bout de course les fleches sont desactivees, pas masquees : les
         retirer decalerait la voisine sous le curseur au moment du clic. */
      if (arriere) arriere.disabled = i <= 0;
      if (avant) avant.disabled = i >= vues.length - 1;

      /* Le rail defile de son cote : sur vingt visuels, la vignette active
         sort du cadre bien avant la fin. `nearest` evite de recentrer a chaque
         pas, ce qui donnerait un rail qui bouge sans arret. */
      var active = vignettes[i];
      if (active && rail && rail.scrollHeight > rail.clientHeight + 4) {
        var haut = active.offsetTop - rail.offsetTop;
        if (haut < rail.scrollTop || haut + active.offsetHeight > rail.scrollTop + rail.clientHeight) {
          active.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      }
    }

    if (avant) {
      avant.addEventListener('pointerenter', function () { preparer(indexCourant() + 1); }, { passive: true });
      avant.addEventListener('focus', function () { preparer(indexCourant() + 1); });
      avant.addEventListener('click', function () {
        allerA(indexCourant() + 1);
      });
    }
    if (arriere) {
      arriere.addEventListener('pointerenter', function () { preparer(indexCourant() - 1); }, { passive: true });
      arriere.addEventListener('focus', function () { preparer(indexCourant() - 1); });
      arriere.addEventListener('click', function () {
        allerA(indexCourant() - 1);
      });
    }

    piste.addEventListener(
      'pointerdown',
      function () {
        var i = indexCourant();
        preparer(i - 1);
        preparer(i + 1);
      },
      { passive: true }
    );

    var attente;
    piste.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(attente);
        attente = window.setTimeout(rafraichir, 60);
      },
      { passive: true }
    );
    window.addEventListener('resize', rafraichir);
    rafraichir();

    /* Apres le chargement complet, prechauffe le second visuel seulement sur
       une connexion convenable. Cela rend le premier swipe instantane sans
       penaliser Save-Data, la 2G ou le rendu initial. */
    function preparerDeuxiemeAuRepos() {
      var connexion = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (connexion && (connexion.saveData || /(^|-)2g$/.test(connexion.effectiveType || ''))) return;
      var lancer = function () { preparer(1); };
      if ('requestIdleCallback' in window) window.requestIdleCallback(lancer, { timeout: 1800 });
      else window.setTimeout(lancer, 700);
    }
    if (document.readyState === 'complete') preparerDeuxiemeAuRepos();
    else window.addEventListener('load', preparerDeuxiemeAuRepos, { once: true });

    /* Changement de variante. Dawn publie `variantChange` sur son bus interne ;
       sa fonction `updateMedia` ne fait rien ici puisque la galerie ne s'appelle
       pas `media-gallery` — c'est volontaire, une structure differente sous ce
       nom la ferait travailler a l'aveugle. On fait donc le saut nous-memes.

       Garde sur `subscribe` : le bus vient de `pubsub.js`, charge par la mise en
       page. S'il manquait, l'abonnement leverait une erreur qui emporterait
       aussi les pastilles et les fleches, alors qu'elles n'en dependent pas. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var media = evt && evt.data && evt.data.variant && evt.data.variant.featured_media;
        if (!media) return;
        for (var i = 0; i < vues.length; i++) {
          if (String(vues[i].dataset.mediaId) === String(media.id)) {
            allerA(i);
            return;
          }
        }
      });
    }
  }

  /* Onglets de version. Le motif ARIA « tablist » ne se resume pas a montrer et
     cacher : les fleches doivent deplacer la selection, et un seul onglet doit
     rester atteignable par tabulation — sinon parcourir la page au clavier
     oblige a traverser toutes les versions une a une. */
  function initOnglets(liste) {
    var onglets = Array.prototype.slice.call(liste.querySelectorAll('[role="tab"]'));
    if (onglets.length < 2) return;

    function activer(i, donnerLeFocus) {
      onglets.forEach(function (onglet, j) {
        var actif = j === i;
        onglet.setAttribute('aria-selected', actif ? 'true' : 'false');
        onglet.tabIndex = actif ? 0 : -1;
        var volet = document.getElementById(onglet.getAttribute('aria-controls'));
        if (volet) volet.hidden = !actif;
      });
      if (donnerLeFocus) onglets[i].focus();
    }

    onglets.forEach(function (onglet, i) {
      onglet.addEventListener('click', function () {
        activer(i, false);
      });
      onglet.addEventListener('keydown', function (e) {
        var pas = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!pas) return;
        e.preventDefault();
        activer((i + pas + onglets.length) % onglets.length, true);
      });
    });
  }

  /* Grille « tout voir ». On s'appuie sur `<dialog>` et `showModal()` : le
     navigateur fournit alors le fond, le piege a focus, la fermeture par
     Echap et le retour du focus au bouton d'origine. Reecrire tout cela a la
     main, c'est se tromper sur un des quatre. */
  function initModaleGalerie(ouvrir) {
    var id = ouvrir.dataset.bmbOuvrirGalerie;
    var modale = document.querySelector('[data-bmb-modale="' + id + '"]');
    if (!modale) return;

    ouvrir.addEventListener('click', function () {
      if (typeof modale.showModal === 'function') {
        modale.showModal();
      } else {
        /* Repli pour les navigateurs sans <dialog> : la grille reste
           atteignable, sans le confort du modal natif. */
        modale.setAttribute('open', '');
      }
      document.body.style.overflow = 'hidden';
    });

    modale.querySelectorAll('[data-bmb-fermer-galerie]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (typeof modale.close === 'function') modale.close();
        else modale.removeAttribute('open');
      });
    });

    // Clic sur le fond : la cible est alors le <dialog> lui-meme, pas le panneau.
    modale.addEventListener('click', function (e) {
      if (e.target === modale && typeof modale.close === 'function') modale.close();
    });

    modale.addEventListener('close', function () {
      document.body.style.overflow = '';
    });
  }

  /* Barre de progression de la piste des produits lies. Elle ne se calcule que
     quand la piste defile vraiment : sur ordinateur la meme liste devient une
     grille, `scrollWidth` vaut alors `clientWidth` et la barre est masquee. */
  function initProgression(barre) {
    var piste = barre.parentElement.querySelector('.bmb-lies__piste');
    var jauge = barre.querySelector('span');
    if (!piste || !jauge) return;

    function rafraichir() {
      var course = piste.scrollWidth - piste.clientWidth;
      if (course <= 1) {
        jauge.style.width = '100%';
        return;
      }
      var partVisible = piste.clientWidth / piste.scrollWidth;
      var avancement = piste.scrollLeft / course;
      jauge.style.width = Math.max(12, partVisible * 100) + '%';
      jauge.style.transform = 'translateX(' + avancement * (100 / Math.max(partVisible, 0.0001) - 100) + '%)';
    }

    piste.addEventListener('scroll', rafraichir, { passive: true });
    window.addEventListener('resize', rafraichir);
    rafraichir();
  }

  /* Chevrons du carrousel de produits lies. Ils avancent d'une PAGE entiere —
     la largeur visible — et non d'une carte : c'est ce qui fait qu'une rangee
     de quatre se remplace par les quatre suivantes, sans laisser une carte a
     moitie coupee au bord. */
  function initFlechesLies(cadre) {
    var piste = cadre.querySelector('.bmb-lies__piste');
    var arriere = cadre.querySelector('[data-bmb-lies-precedent]');
    var avant = cadre.querySelector('[data-bmb-lies-suivant]');
    if (!piste || !arriere || !avant) return;

    /* Le contenu arrive par remplacement, et l'observateur peut declencher
       plusieurs fois pour un meme remplacement : sans ce verrou, les
       ecouteurs s'empilent et un clic avance de plusieurs pages d'un coup. */
    if (cadre.dataset.bmbArme === '1') return;
    cadre.dataset.bmbArme = '1';

    function etat() {
      var course = piste.scrollWidth - piste.clientWidth;
      arriere.disabled = piste.scrollLeft <= 2;
      avant.disabled = piste.scrollLeft >= course - 2;
    }

    function bouger(sens) {
      piste.scrollBy({ left: sens * piste.clientWidth, behavior: 'smooth' });
    }

    arriere.addEventListener('click', function () { bouger(-1); });
    avant.addEventListener('click', function () { bouger(1); });
    piste.addEventListener('scroll', etat, { passive: true });
    window.addEventListener('resize', etat);
    etat();

    /* Le premier appel tombe pendant que le navigateur pose encore la mise en
       page : `scrollWidth` et `clientWidth` valent alors la meme chose, et
       l'etat calcule est faux. On repasse une fois la mise en page etablie. */
    requestAnimationFrame(function () {
      requestAnimationFrame(etat);
    });
  }

  /* Comparatif avant / apres. Tout le travail est fait par le CSS : le script
     ne fait que reporter la valeur du champ dans `--pos`. Le glissement, le
     clic n'importe ou sur l'image, les fleches du clavier et l'annonce vocale
     viennent du `input[type="range"]` — un div avec des ecouteurs `mousemove`,
     ce que faisait le gabarit d'origine, n'en donne aucun des quatre. */
  function initComparaison(cadre) {
    var curseur = cadre.querySelector('.bmb-compare__curseur');
    if (!curseur || cadre.dataset.bmbArme === '1') return;
    cadre.dataset.bmbArme = '1';

    function poser() {
      cadre.style.setProperty('--pos', curseur.value + '%');
    }

    curseur.addEventListener('input', poser);
    poser();
  }

  /* Affiche de la video. Le clic, lui, est gere par `deferred-media` (Dawn) :
     le lecteur vit dans un `<template>` et n'est greffe qu'au premier appui.
     Il ne reste ici que le repli d'affiche.

     `maxresdefault` n'existe que pour les videos televersees en haute
     definition — 24 des 130 du catalogue n'en ont pas. Le piege : `i.ytimg.com`
     ne repond PAS 404 dans ce cas, il sert une vignette grise de 120 x 90 avec
     un code 200. L'evenement `error` ne se declenche donc jamais, et l'affiche
     partait etiree de 120 px a 900. Seule la taille decodee trahit l'absence. */
  function initVideo(bouton) {
    if (bouton.dataset.bmbArme === '1') return;
    bouton.dataset.bmbArme = '1';

    var affiche = bouton.querySelector('.bmb-video__affiche');
    var repli = bouton.dataset.bmbVideoRepli;
    if (!affiche || !repli) return;

    function verifier() {
      if (affiche.dataset.bmbRepli === '1') return;
      if (affiche.naturalWidth > 320) return;
      affiche.dataset.bmbRepli = '1';
      affiche.src = repli;
    }

    affiche.addEventListener('load', verifier);
    affiche.addEventListener('error', verifier);
    if (affiche.complete) verifier();
  }

  /* Carrousel de cartes sur telephone — sert aux atouts comme aux etapes du
     guide. Les pastilles et les fleches ne font que declencher un defilement :
     la piste reste scrollable au doigt, et l'etat se lit dans `scrollLeft`
     plutot que dans une variable a tenir a jour, donc l'affichage ne peut pas
     se desynchroniser du geste. */
  function initCarrousel(cadre) {
    if (cadre.dataset.bmbArme === '1') return;
    cadre.dataset.bmbArme = '1';

    var piste = cadre.querySelector('[data-bmb-piste]');
    var boitePoints = cadre.querySelector('[data-bmb-points]');
    var commandes = cadre.querySelector('.bmb-carrousel__commandes');
    var prec = cadre.querySelector('[data-bmb-prec]');
    var suiv = cadre.querySelector('[data-bmb-suiv]');
    if (!piste || !boitePoints) return;

    var cartes = Array.prototype.slice.call(piste.children);
    if (cartes.length < 2) {
      if (commandes) commandes.style.display = 'none';
      return;
    }

    function versCarte(i) {
      var cible = cartes[Math.max(0, Math.min(cartes.length - 1, i))];
      piste.scrollTo({ left: cible.offsetLeft - piste.offsetLeft, behavior: 'smooth' });
    }

    var pastilles = cartes.map(function (carte, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', String(i + 1));
      b.addEventListener('click', function () {
        versCarte(i);
      });
      boitePoints.appendChild(b);
      return b;
    });

    function indexCourant() {
      if (!piste.clientWidth) return 0;
      return Math.round(piste.scrollLeft / (piste.scrollWidth / cartes.length));
    }

    function rafraichir() {
      var i = indexCourant();
      pastilles.forEach(function (b, j) {
        b.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
      if (prec) prec.disabled = i <= 0;
      if (suiv) suiv.disabled = i >= cartes.length - 1;
    }

    if (prec) {
      prec.addEventListener('click', function () {
        versCarte(indexCourant() - 1);
      });
    }
    if (suiv) {
      suiv.addEventListener('click', function () {
        versCarte(indexCourant() + 1);
      });
    }

    var attente;
    piste.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(attente);
        attente = window.setTimeout(rafraichir, 60);
      },
      { passive: true }
    );
    window.addEventListener('resize', rafraichir);
    rafraichir();
  }

  /* Barre d'achat fixe inspiree du comportement LEGO : elle n'apparait qu'une
     fois le formulaire principal depasse, puis se retire avant le pied de page.
     Elle ne possede aucune logique panier propre. Le clic delegue au bouton
     natif Dawn, ce qui conserve le panier tiroir, les erreurs et les apps. */
  function initStickyAchat(barre) {
    if (barre.dataset.bmbStickyPret === '1') return;

    var id = barre.dataset.bmbStickyAchat;
    var produit = barre.closest('.bmb-produit');
    var boutonPrincipal = document.getElementById('ProductSubmitButton-' + id);
    var formulaire = document.getElementById('product-form-' + id);
    var prixPrincipal = document.getElementById('price-' + id);
    var blocBoutons = boutonPrincipal ? boutonPrincipal.closest('.bmb-produit__boutons') : null;
    var boutonSticky = barre.querySelector('[data-bmb-sticky-ajouter]');
    var libelleSticky = barre.querySelector('[data-bmb-sticky-libelle]');
    var prixSticky = Array.prototype.slice.call(barre.querySelectorAll('[data-bmb-sticky-prix]'));
    var blocVersionSticky = barre.querySelector('[data-bmb-sticky-version]');
    var selectVersionSticky = barre.querySelector('[data-bmb-sticky-version-select]');
    var navigation = barre.querySelector('.bmb-sticky-achat__navigation');
    var liensNavigation = Array.prototype.slice.call(
      barre.querySelectorAll('[data-bmb-sticky-lien]')
    );

    if (!produit || !boutonPrincipal || !formulaire || !blocBoutons || !boutonSticky) return;

    barre.dataset.bmbStickyPret = '1';

    function nettoyerIds(element) {
      if (element.removeAttribute) element.removeAttribute('id');
      element.querySelectorAll('[id]').forEach(function (noeud) {
        noeud.removeAttribute('id');
      });
    }

    function synchroniserPrix() {
      prixPrincipal = document.getElementById('price-' + id);
      if (!prixPrincipal) return;
      var source = prixPrincipal.querySelector('.price');

      prixSticky.forEach(function (cible) {
        while (cible.firstChild) cible.removeChild(cible.firstChild);

        if (source) {
          var copie = source.cloneNode(true);
          nettoyerIds(copie);
          cible.appendChild(copie);
        } else {
          cible.textContent = prixPrincipal.textContent.trim();
        }
      });
    }

    function synchroniserBouton() {
      var boutonActuel = document.getElementById('ProductSubmitButton-' + id);
      if (!boutonActuel) return;
      boutonPrincipal = boutonActuel;

      var libellePrincipal = boutonActuel.querySelector('span');
      var charge = boutonActuel.classList.contains('loading');
      var indisponible =
        boutonActuel.disabled || boutonActuel.getAttribute('aria-disabled') === 'true';

      if (libellePrincipal && libelleSticky) {
        libelleSticky.textContent = libellePrincipal.textContent.trim();
      }

      boutonSticky.disabled = indisponible;
      boutonSticky.setAttribute('aria-disabled', indisponible ? 'true' : 'false');
      boutonSticky.classList.toggle('is-loading', charge);
    }

    function radiosVersionActifs() {
      var fieldsets = Array.prototype.slice.call(
        produit.querySelectorAll('.product-form__input--pill')
      ).filter(function (fieldset) {
        var selecteur = fieldset.closest('variant-selects');
        return !selecteur || selecteur.style.display !== 'none';
      });

      for (var i = 0; i < fieldsets.length; i += 1) {
        var radios = Array.prototype.slice.call(
          fieldsets[i].querySelectorAll('input[type="radio"]')
        );
        var nomOption = radios.length
          ? String(radios[0].dataset.optionName || '').trim().toLowerCase()
          : '';
        var legende = fieldsets[i].querySelector('legend');
        var texteLegende = String(legende ? legende.textContent : '').trim().toLowerCase();

        if (nomOption === 'version' || texteLegende === 'version') return radios;
      }

      // Repli : un produit dont l'unique option ne s'appelle pas "Version"
      // — la carte cadeau et son option "Valeurs", par exemple — doit quand
      // meme piloter le selecteur de la barre sticky. On ne prend ce repli
      // que s'il n'y a aucune ambiguite, c'est-a-dire un seul groupe d'options.
      if (fieldsets.length === 1) {
        var seuls = Array.prototype.slice.call(
          fieldsets[0].querySelectorAll('input[type="radio"]')
        );
        if (seuls.length > 1) return seuls;
      }

      return [];
    }

    function synchroniserSelecteurVersion() {
      if (!blocVersionSticky || !selectVersionSticky) return;

      var radios = radiosVersionActifs();
      if (radios.length < 2) {
        blocVersionSticky.hidden = true;
        selectVersionSticky.replaceChildren();
        delete selectVersionSticky.dataset.bmbVersionSignature;
        return;
      }

      var signature = radios
        .map(function (radio) {
          var indisponible = radio.disabled || radio.classList.contains('disabled');
          return radio.value + ':' + (indisponible ? '0' : '1');
        })
        .join('|');

      if (selectVersionSticky.dataset.bmbVersionSignature !== signature) {
        var fragment = document.createDocumentFragment();
        radios.forEach(function (radio) {
          var option = document.createElement('option');
          option.value = radio.value;
          option.textContent = radio.value;
          option.disabled = radio.disabled || radio.classList.contains('disabled');
          fragment.appendChild(option);
        });
        selectVersionSticky.replaceChildren(fragment);
        selectVersionSticky.dataset.bmbVersionSignature = signature;
      }

      var radioSelectionnee = radios.find(function (radio) {
        return radio.checked;
      });
      if (radioSelectionnee) selectVersionSticky.value = radioSelectionnee.value;
      blocVersionSticky.hidden = false;
    }

    function synchroniserTout() {
      synchroniserPrix();
      synchroniserBouton();
      synchroniserSelecteurVersion();
    }

    boutonSticky.addEventListener('click', function () {
      if (boutonSticky.disabled) return;
      var boutonActuel = document.getElementById('ProductSubmitButton-' + id);
      if (boutonActuel) boutonActuel.click();
    });

    if (selectVersionSticky) {
      selectVersionSticky.addEventListener('change', function () {
        var radioCible = radiosVersionActifs().find(function (radio) {
          return radio.value === selectVersionSticky.value;
        });
        if (!radioCible || radioCible.checked || radioCible.disabled) return;

        /* Dawn remet le focus sur l'id de l'option apres son fetch. Comme le
           vrai radio vit bien plus haut dans la page, ce focus ferait remonter
           le visiteur apres un choix dans la barre fixe. L'id temporaire est
           capture par Dawn pendant l'evenement puis retire aussitot : la mise
           a jour de variante reste native, sans cible de focus hors ecran. */
        var idOriginal = radioCible.id;
        radioCible.id = idOriginal + '--bmb-sticky';
        try {
          radioCible.click();
        } finally {
          radioCible.id = idOriginal;
        }
      });
    }

    if (prixPrincipal) {
      new MutationObserver(synchroniserPrix).observe(prixPrincipal, {
        childList: true,
        subtree: true,
      });
    }

    var infoProduit = document.getElementById('ProductInfo-' + id);
    if (infoProduit) {
      var synchronisationPlanifiee = false;
      new MutationObserver(function () {
        if (synchronisationPlanifiee) return;
        synchronisationPlanifiee = true;
        window.requestAnimationFrame(function () {
          synchronisationPlanifiee = false;
          synchroniserTout();
        });
      }).observe(infoProduit, { childList: true, subtree: true });
    }

    new MutationObserver(synchroniserBouton).observe(boutonPrincipal, {
      attributes: true,
      attributeFilter: ['aria-disabled', 'class', 'disabled'],
      childList: true,
      subtree: true,
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        window.requestAnimationFrame(function () {
          synchroniserTout();
        });
      });
    }

    /* Les trois bandes editoriales vivent dans une autre section Shopify.
       On les relie par leur titre, avec l'ordre visuel comme repli. Cela evite
       de dupliquer leurs contenus ou de coupler le sticky a un identifiant de
       section genere par l'editeur. */
    function texteNormalise(valeur) {
      return String(valeur || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
    }

    function trouverCiblesNavigation() {
      var volets = Array.prototype.slice.call(document.querySelectorAll('.bmb-details__volet'));
      var cibles = { overview: produit };
      var definitions = [
        { type: 'features', id: 'BmbFeatures', motif: /feature|caracteristique|funktion/ },
        { type: 'instructions', id: 'BmbInstructions', motif: /instruction|installation|guide|anleitung/ },
        { type: 'reviews', id: 'BmbCustomerReviews', motif: /review|avis|bewertung/ },
      ];

      definitions.forEach(function (definition, index) {
        var cible = volets.find(function (volet) {
          var resume = volet.querySelector('summary');
          return definition.motif.test(texteNormalise(resume ? resume.textContent : ''));
        });

        if (!cible) cible = volets[index];
        if (!cible) return;

        cible.id = definition.id;
        cible.dataset.bmbStickyCible = definition.type;
        cibles[definition.type] = cible;
      });

      // Une section peut se declarer elle-meme comme cible en portant
      // data-bmb-sticky-cible. Necessaire sur les gabarits sans volets
      // — la fiche carte cadeau, par exemple, dont les avis vivent dans
      // leur propre section. Un volet deja trouve n'est jamais ecrase.
      Array.prototype.slice.call(
        document.querySelectorAll('[data-bmb-sticky-cible]')
      ).forEach(function (element) {
        var type = element.dataset.bmbStickyCible;
        if (!type || cibles[type]) return;
        if (!element.id) element.id = 'BmbCible-' + type;
        cibles[type] = element;
      });

      return cibles;
    }

    var ciblesNavigation = trouverCiblesNavigation();
    var navigationCourante = '';
    var mouvementReduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function centrerLien(lien) {
      if (!navigation || navigation.scrollWidth <= navigation.clientWidth) return;
      var position = lien.offsetLeft - (navigation.clientWidth - lien.offsetWidth) / 2;
      navigation.scrollTo({
        left: Math.max(0, position),
        behavior: mouvementReduit ? 'auto' : 'smooth',
      });
    }

    function activerNavigation(type, centrer) {
      if (!type || navigationCourante === type) return;
      navigationCourante = type;

      liensNavigation.forEach(function (lien) {
        var actif = lien.dataset.bmbStickyLien === type;
        lien.classList.toggle('is-active', actif);
        if (actif) {
          lien.setAttribute('aria-current', 'location');
          if (centrer) centrerLien(lien);
        } else {
          lien.removeAttribute('aria-current');
        }
      });
    }

    liensNavigation.forEach(function (lien) {
      var type = lien.dataset.bmbStickyLien;
      var cible = ciblesNavigation[type];

      if (!cible) {
        lien.hidden = true;
        return;
      }

      lien.href = '#' + cible.id;

      if (cible.matches('details')) {
        var resume = cible.querySelector('summary');
        var titre = resume ? resume.textContent.trim() : '';
        if (titre) lien.textContent = titre;
      }

      lien.addEventListener('click', function () {
        if (cible.matches('details')) cible.open = true;
        activerNavigation(type, true);
      });
    });

    var navigationPlanifiee = false;

    function mesurerNavigation() {
      var typeActif = 'overview';
      var seuil = Math.max(96, window.innerHeight * 0.28);

      ['features', 'instructions', 'reviews'].forEach(function (type) {
        var cible = ciblesNavigation[type];
        if (cible && cible.getBoundingClientRect().top <= seuil) typeActif = type;
      });

      activerNavigation(typeActif, true);
      navigationPlanifiee = false;
    }

    function planifierNavigation() {
      if (navigationPlanifiee) return;
      navigationPlanifiee = true;
      window.requestAnimationFrame(mesurerNavigation);
    }

    window.addEventListener('scroll', planifierNavigation, { passive: true });
    window.addEventListener('resize', planifierNavigation);

    var boutonDepasse = false;
    var piedVisible = false;

    function afficherSiUtile() {
      var visible = boutonDepasse && !piedVisible;
      barre.dataset.visible = visible ? 'true' : 'false';
      barre.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (visible) barre.removeAttribute('inert');
      else barre.setAttribute('inert', '');
    }

    var affichagePlanifie = false;

    function mesurerAffichage() {
      var rectangleBouton = blocBoutons.getBoundingClientRect();
      var pied = document.querySelector('footer');
      var rectanglePied = pied ? pied.getBoundingClientRect() : null;

      boutonDepasse = rectangleBouton.bottom <= 0;
      piedVisible = rectanglePied
        ? rectanglePied.top < window.innerHeight && rectanglePied.bottom > 0
        : false;
      afficherSiUtile();
      affichagePlanifie = false;
    }

    function planifierAffichage() {
      if (affichagePlanifie) return;
      affichagePlanifie = true;
      window.requestAnimationFrame(mesurerAffichage);
    }

    window.addEventListener('scroll', planifierAffichage, { passive: true });
    window.addEventListener('resize', planifierAffichage);

    synchroniserTout();
    mesurerNavigation();
    barre.hidden = false;
    mesurerAffichage();
  }

  /* Cartes de versions. L'habillage est ajoute autour des radios natives
     de Dawn au lieu de remplacer leur comportement : un clic declenche encore
     exactement le meme changement de variante et la meme mise a jour panier. */
  function initCartesVersions(conteneur) {
    /* Dawn garde l'ancien `variant-selects` masque pendant 500 ms lorsqu'il
       insere le nouveau. Ne compter que le selecteur actif evite de prendre
       cette transition pour un bloc ambigu et d'afficher les pills natives. */
    var fieldsets = Array.prototype.slice.call(
      conteneur.querySelectorAll('.product-form__input--pill')
    ).filter(function (fieldset) {
      var selecteur = fieldset.closest('variant-selects');
      return !selecteur || selecteur.style.display !== 'none';
    });
    if (fieldsets.length !== 1) return;

    var fieldset = fieldsets[0];
    if (fieldset.classList.contains('bmb-version-cartes')) return;

    var radios = Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"]'));
    if (radios.length < 2) return;

    var nomOption = String(radios[0].dataset.optionName || '').trim().toLowerCase();
    var estSelecteurVersions = nomOption === 'version' || nomOption === 'vrsion';
    if (!estSelecteurVersions) return;

    var prixParVersion = {};
    var metasVersions = Array.prototype.slice.call(
      conteneur.querySelectorAll('[data-bmb-version-meta]')
    );
    metasVersions.forEach(function (meta) {
      prixParVersion[String(meta.dataset.bmbVersionValue || '').toLowerCase()] =
        meta.dataset.bmbVersionPrice || '';
    });

    var copiesVersions = {};
    var donneesCopies = conteneur.querySelector('[data-bmb-version-copy]');
    if (donneesCopies) {
      try {
        copiesVersions = JSON.parse(donneesCopies.textContent || '{}');
      } catch (erreur) {
        copiesVersions = {};
      }
    }

    var titre = fieldset.querySelector('legend');
    if (titre && conteneur.dataset.bmbVersionTitre) {
      titre.textContent = conteneur.dataset.bmbVersionTitre;
    }

    fieldset.classList.add('bmb-version-cartes');
    conteneur.dataset.bmbCartesVersionsPretes = '1';

    radios.forEach(function (radio, indexRadio) {
      var etiquette = radio.nextElementSibling;
      if (!etiquette || etiquette.tagName !== 'LABEL') return;

      var valeur = String(radio.value || '');
      var cle = valeur
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
      var contient = function () {
        return Array.prototype.slice.call(arguments).some(function (terme) {
          return cle.indexOf(terme) !== -1;
        });
      };
      var estRemote = contient('remote', 'telecommande', 'fernbedienung');
      var estRgb =
        /\brgb\b/.test(cle) ||
        contient('multi-color', 'multicolor', 'multicolore', 'mehrfarbig', 'colorful');
      var estMusique = contient('music', 'musical', 'sound', 'musique', 'sonore', 'musik', 'klang');
      var estInteractive = contient('interactive', 'interactif', 'interaktiv');
      var estControleLumiere = contient(
        'light control',
        'light-control',
        'controle lumiere',
        'lichtsteuer',
        'touch',
        'tactile',
        'beruhr'
      );
      var estControleVocal = contient('voice control', 'controle vocal', 'sprachsteuer', 'stimmsteuer');
      var estUpgraded = contient('upgraded', 'ameliore', 'verbessert');
      var estClassic = contient('classic', 'classique', 'klassisch', 'standard', 'standart');
      var estCannon = contient('cannon', 'canon', 'kanonen');
      var estPower = contient(
        'power kit',
        'power system',
        'kit alimentation',
        "kit d'alimentation",
        'systeme alimentation',
        "systeme d'alimentation",
        'powersystem',
        'stromversorgung'
      );
      var estPowerSeul =
        estPower &&
        (contient('only', 'seul', 'nur') ||
          cle === 'power system kit' ||
          cle === 'powersystem-kit');
      var estHolyLight = contient('holy light', 'lumiere sacree', 'heiliges licht');
      var estPremium = contient('premium', 'collector edition', 'edition collector', 'ultimate', 'ultime');
      var estUpdated = contient('updated', 'actualise', 'mise a jour', 'aktualisiert');
      var estDecoration = contient(
        'cherry blossom decoration',
        'decoration pack',
        'pack decoration',
        'no light',
        'sans lumiere',
        'ohne licht'
      );
      var estDisplayBundle = contient(
        'display board',
        'wall display',
        'display frame',
        "panneau d'exposition",
        'cadre mural',
        'wanddisplay',
        'display-board'
      );
      var estCouleur =
        /^(brown|green|gold|pink|brun|vert|dore|rose|braun|grun|gruen|rosa)( version)?$/.test(cle);
      var estLongueur = /^\d+\s*cm$/.test(cle);
      var estEdition = /^(version|edition)\s*\d+$/.test(cle);
      var description = '';
      var atoutsBruts = '';
      var badgeTexte = '';

      function utiliserCopie(type) {
        var copie = copiesVersions[type] || {};
        description = copie.description || '';
        atoutsBruts = copie.benefits || '';
        badgeTexte = copie.badge || '';
      }

      if (estDisplayBundle) {
        utiliserCopie('display_bundle');
      } else if (estDecoration) {
        utiliserCopie('decoration');
      } else if (estCannon && estRemote) {
        utiliserCopie('cannon_remote');
      } else if (estInteractive && estRemote) {
        utiliserCopie('interactive_remote');
      } else if (estUpgraded && estMusique) {
        utiliserCopie('upgraded_music');
      } else if (estRgb && estMusique) {
        utiliserCopie('rgb_music');
      } else if (estRemote && estPower) {
        utiliserCopie('remote_power_bundle');
      } else if (estClassic && estPower) {
        utiliserCopie('power_bundle');
      } else if (estPowerSeul) {
        utiliserCopie('power_addon');
      } else if (estPower) {
        utiliserCopie('power_bundle');
      } else if (estHolyLight && estRemote) {
        utiliserCopie('holy_light_remote');
      } else if (estUpgraded && estRemote) {
        utiliserCopie('upgraded_remote');
      } else if (estRemote && estMusique) {
        description = conteneur.dataset.bmbSoundRemoteDescription;
        atoutsBruts = conteneur.dataset.bmbSoundRemoteAtouts;
        badgeTexte = conteneur.dataset.bmbSoundRemoteBadge;
      } else if (estRgb && estRemote) {
        description = conteneur.dataset.bmbRgbRemoteDescription;
        atoutsBruts = conteneur.dataset.bmbRgbRemoteAtouts;
        badgeTexte = conteneur.dataset.bmbRgbRemoteBadge;
      } else if (estInteractive) {
        utiliserCopie('interactive');
      } else if (estControleVocal) {
        utiliserCopie('voice_control');
      } else if (estControleLumiere) {
        utiliserCopie('light_control');
      } else if (estHolyLight) {
        utiliserCopie('holy_light');
      } else if (estPremium) {
        utiliserCopie('premium');
      } else if (estUpgraded) {
        utiliserCopie('upgraded');
      } else if (estMusique) {
        utiliserCopie('sound_music');
      } else if (estRgb) {
        utiliserCopie('rgb');
      } else if (estUpdated) {
        utiliserCopie('updated');
      } else if (estCannon) {
        description = conteneur.dataset.bmbCannonDescription;
        atoutsBruts = conteneur.dataset.bmbCannonAtouts;
        badgeTexte = conteneur.dataset.bmbCannonBadge;
      } else if (estCouleur) {
        utiliserCopie('colour');
      } else if (estLongueur) {
        utiliserCopie('length');
      } else if (estEdition) {
        utiliserCopie('edition');
      } else if (estRemote) {
        description = conteneur.dataset.bmbRemoteDescription;
        atoutsBruts = conteneur.dataset.bmbRemoteAtouts;
        badgeTexte = conteneur.dataset.bmbRemoteBadge;
      } else if (estClassic) {
        description = conteneur.dataset.bmbClassicDescription;
        atoutsBruts = conteneur.dataset.bmbClassicAtouts;
      } else {
        utiliserCopie('special');
      }
      var prix =
        prixParVersion[cle] ||
        (metasVersions[indexRadio] && metasVersions[indexRadio].dataset.bmbVersionPrice) ||
        '';
      var contenusAccessibles = Array.prototype.slice.call(
        etiquette.querySelectorAll('.visually-hidden')
      ).map(function (element) {
        return element.cloneNode(true);
      });

      etiquette.replaceChildren();
      etiquette.classList.add('bmb-version-carte');

      var entete = document.createElement('span');
      entete.className = 'bmb-version-carte__entete';

      var marqueur = document.createElement('span');
      marqueur.className = 'bmb-version-carte__radio';
      marqueur.setAttribute('aria-hidden', 'true');

      var copie = document.createElement('span');
      copie.className = 'bmb-version-carte__copie';

      var nom = document.createElement('span');
      nom.className = 'bmb-version-carte__nom';
      nom.textContent = valeur;
      copie.appendChild(nom);

      if (description) {
        var texte = document.createElement('span');
        texte.className = 'bmb-version-carte__description';
        texte.textContent = description;
        copie.appendChild(texte);
      }

      var prixElement = document.createElement('span');
      prixElement.className = 'bmb-version-carte__prix';
      prixElement.textContent = prix;

      entete.appendChild(marqueur);
      entete.appendChild(copie);
      entete.appendChild(prixElement);
      etiquette.appendChild(entete);

      if (badgeTexte) {
        var badge = document.createElement('span');
        badge.className = 'bmb-version-carte__badge';
        badge.textContent = badgeTexte;
        etiquette.appendChild(badge);
      }

      var atouts = document.createElement('span');
      atouts.className = 'bmb-version-carte__atouts';
      atouts.setAttribute('role', 'list');
      String(atoutsBruts || '')
        .split('|')
        .map(function (atout) {
          return atout.trim();
        })
        .filter(Boolean)
        .forEach(function (atout) {
          var ligne = document.createElement('span');
          ligne.className = 'bmb-version-carte__atout';
          ligne.setAttribute('role', 'listitem');
          ligne.textContent = atout;
          atouts.appendChild(ligne);
        });
      if (atouts.childElementCount > 0) {
        etiquette.appendChild(atouts);
      }

      contenusAccessibles.forEach(function (element) {
        etiquette.appendChild(element);
      });
    });

    function synchroniserCartes() {
      radios.forEach(function (radio) {
        var etiquette = radio.nextElementSibling;
        if (!etiquette || !etiquette.classList.contains('bmb-version-carte')) return;
        var selectionnee = radio.checked;
        var atouts = etiquette.querySelector('.bmb-version-carte__atouts');
        etiquette.classList.toggle('is-selected', selectionnee);
        if (atouts) atouts.hidden = !selectionnee;
      });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', synchroniserCartes);
    });
    synchroniserCartes();
  }

  function init(racine) {
    var r = racine || document;
    r.querySelectorAll('[data-bmb-compare]').forEach(initComparaison);
    r.querySelectorAll('[data-bmb-carrousel]').forEach(initCarrousel);
    r.querySelectorAll('[data-bmb-video]').forEach(initVideo);
    r.querySelectorAll('[data-bmb-galerie]').forEach(initGalerie);
    r.querySelectorAll('[data-bmb-onglets]').forEach(initOnglets);
    r.querySelectorAll('[data-bmb-ouvrir-galerie]').forEach(initModaleGalerie);
    r.querySelectorAll('[data-bmb-progression]').forEach(initProgression);
    r.querySelectorAll('[data-bmb-lies]').forEach(initFlechesLies);
    r.querySelectorAll('[data-bmb-cartes-versions]').forEach(initCartesVersions);
    r.querySelectorAll('[data-bmb-sticky-achat]').forEach(initStickyAchat);
  }

  /* `product-recommendations` remplace tout son contenu par un appel reseau
     apres le chargement : le balisage rendu cote serveur ne survit pas. Sans
     ce reveil, la barre de progression est branchee sur des elements qui
     n'existent plus, et elle reste figee sur la seule version que le visiteur
     voie jamais. On observe donc le remplacement plutot que de parier sur un
     evenement — Dawn n'en emet aucun. */
  function surveillerRecommandations(racine) {
    (racine || document).querySelectorAll('product-recommendations').forEach(function (bloc) {
      if (bloc.dataset.bmbSurveille === '1') return;
      bloc.dataset.bmbSurveille = '1';
      new MutationObserver(function () {
        init(bloc);
      }).observe(bloc, { childList: true, subtree: true });
    });
  }

  /* Dawn remplace le bloc du selecteur apres un changement de variante. Dans
     l'editeur Shopify, c'est parfois tout `product-info` qui est remplace : un
     observer pose sur l'ancien composant disparait alors avec lui. La page,
     elle, reste en place. On l'observe donc une seule fois et on ne traite que
     les mutations qui touchent ou ajoutent un selecteur BMB. */
  function surveillerCartesVersions(racine) {
    var documentCible = racine && racine.ownerDocument ? racine.ownerDocument : document;
    var elementRacine = documentCible.documentElement;
    if (!elementRacine || elementRacine.dataset.bmbCartesVersionsObservees === '1') return;
    if (!documentCible.querySelector('[data-bmb-cartes-versions]')) return;

    elementRacine.dataset.bmbCartesVersionsObservees = '1';

    new MutationObserver(function (mutations) {
      var conteneurs = [];

      function ajouter(conteneur) {
        if (!conteneur || conteneurs.indexOf(conteneur) !== -1) return;
        conteneurs.push(conteneur);
      }

      mutations.forEach(function (mutation) {
        var cible = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        if (cible && cible.closest) {
          ajouter(cible.closest('[data-bmb-cartes-versions]'));
        }

        mutation.addedNodes.forEach(function (noeud) {
          if (noeud.nodeType !== 1 && noeud.nodeType !== 11) return;

          if (noeud.matches && noeud.matches('[data-bmb-cartes-versions]')) {
            ajouter(noeud);
          }
          if (noeud.closest) {
            ajouter(noeud.closest('[data-bmb-cartes-versions]'));
          }
          if (noeud.querySelectorAll) {
            noeud.querySelectorAll('[data-bmb-cartes-versions]').forEach(ajouter);
          }
        });
      });

      conteneurs.forEach(initCartesVersions);
    }).observe(documentCible.body || elementRacine, { childList: true, subtree: true });
  }

  function demarrer(racine) {
    init(racine);
    surveillerRecommandations(racine);
    surveillerCartesVersions(racine);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      demarrer(document);
    });
  } else {
    demarrer(document);
  }

  /* L'editeur de theme reconstruit une section sans recharger la page : sans ce
     branchement, la galerie perd ses pastilles des la premiere modification. */
  document.addEventListener('shopify:section:load', function (e) {
    demarrer(e.target);
  });
})();
